/** @format */

import React from 'react'

import Images from '../Images'

import './style.css'

export default function AuthSideBox() {
	return (
		<div className='ph-auth-sidebox-background-container'>
			<div className='ph-auth-sidebox-background-inner-container'>
				<Images
					classContent={'ph-auth-sidebox-logo'}
					// PARCHE: OPTIMIZAR
					// webp={`${process.env.REACT_APP_GENERAL_STORAGE_IMAGES}/panel-admin/logo-pharol-blanco.webp`}
					// jp2={`${process.env.REACT_APP_GENERAL_STORAGE_IMAGES}/panel-admin/logo-pharol-blanco.jp2`}
					// jxr={`${process.env.REACT_APP_GENERAL_STORAGE_IMAGES}/panel-admin/logo-pharol-blanco.jxr`}
					default={'https://storage.googleapis.com/tirx-resources-production/381502a2-1d4c-417b-8303-576992432855.webp'} 
					title={'Logo Side Box'}
				/>
				<div>
					<h1 className='ph-auth-sidebox-main-title'>Panel de Administración</h1>
					<p className='ph-auth-sidebox-main-description'>
						Marketplace Farmacéutico con oferta de farmacias legalmente constituidas y establecidas.
					</p>
				</div>
				{/* <div className='ph-auth-sidebox-main-footer-container'>
					<h3 className='ph-auth-sidebox-main-footer-title'>
						<a href='https://www.pharol.cl' target='_blank' rel='noopener noreferrer'>
							@ 2020
						</a>
					</h3>
					<ul className='ph-auth-sidebox-main-footer-list'>
						<li className='ph-auth-sidebox-main-footer-links mr-15'>
							<a href='https://www.pharol.cl/terms-conditions' target='_blank' rel='noopener noreferrer'>
								Legal
							</a>
						</li>
						<li className='ph-auth-sidebox-main-footer-links'>
							<a href='https://www.pharol.cl/policies' target='_blank' rel='noopener noreferrer'>
								Privacy
							</a>
						</li>
					</ul>
				</div> */}
			</div>
		</div>
	)
}
